import React from 'react'
import { Editor, EditorState, ContentState, convertFromHTML, RichUtils } from "draft-js";
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import RedoIcon from '../../images/redo.svg';
import UndoIcon from '../../images/undo.svg';
import BulletListIcon from '../../images/Bullet.svg';
import NumberListIcon from '../../images/Bullet-number.svg';
import ItalicIcon from '../../images/italic.svg';
import LinkIcon from '../../images/link-icon.svg';
import PlusCircleIcon from '../../assets/images/plus-circle.svg';
//import AbcIcon from '../../images/abc.svg';
import 'draft-js/dist/Draft.css';
import SummaryToolTip from './SummaryToolTip';
import { stripTags, urlWithProtocol } from '../../helper';

class DraftEditor extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.value != '') {
            this.state = {
                editorState: EditorState.createWithContent(stateFromHTML(this.props.value)),
                hidePhrasesButton: window?.location?.href?.includes('allinone')
            };
        } else {
            this.state = {
                editorState: EditorState.createEmpty(),
                hidePhrasesButton: window?.location?.href?.includes('allinone')
            }
        }
        
        // To handle change in the editor
        this.onChange = (editorState) => {
            let currentContent = stateToHTML(editorState.getCurrentContent());
            //strip the specific tags from the current content
            currentContent = stripTags(currentContent, ['code']);
            this.setState({
                editorState
            }, () => {
                this.props.onInputChange(currentContent);
            })
        }

        // To handle key commands
        this.handleKeyCommand = (command, editorState) => {
            const newState = RichUtils.handleKeyCommand(editorState, command);
            if (newState) {
                this.onChange(newState);
            }
        }

        this.onBoldClick = (e) => {
            e.preventDefault();
            e.stopPropagation(e);
            this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'BOLD'));
        }

        this.onItalicsClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'ITALIC'));
        }
        this.onStrikeClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'STRIKETHROUGH'));
        }

        this.onUnderlineClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'UNDERLINE'));
        }

        this.onBulletPointClick = (e) => {
            //console.log('bullet clicked');
            this.onChange(RichUtils.toggleBlockType(this.state.editorState, 'unordered-list-item'));
        }
        this.onListingPointClick = (e) => {
            //console.log('bullet clicked');
            this.onChange(RichUtils.toggleBlockType(this.state.editorState, 'ordered-list-item'));
        }

        this.onUndoClick = (e) => {
            this.onChange(EditorState.undo(this.state.editorState));
        }
        this.onRedoClick = (e) => {
            this.onChange(EditorState.redo(this.state.editorState));
        }
        this.onAddLinkClick = (e) => {
            try{
                const editorState = this.state.editorState;
                const selection = editorState.getSelection();
                let link = window.prompt('Enter URL for link -')
                if (!link) {
                this.onChange(RichUtils.toggleLink(editorState, selection, null));
                return 'handled';
                }
                //if(!/^(https?:)?\/\//.test(link)) link = `\\\\${link}`
                link = urlWithProtocol(link)
                const content = editorState.getCurrentContent();
                const contentWithEntity = content.createEntity('LINK', 'MUTABLE', { url: link, target:'_blank'});
                const newEditorState = EditorState.push(editorState, contentWithEntity, 'create-entity');
                const entityKey = contentWithEntity.getLastCreatedEntityKey();
                this.onChange(RichUtils.toggleLink(newEditorState, selection, entityKey))
            }catch(ex)  {
                //To catch exceptions "Got unexpected null or undefined" but don't do anything
                /*
                Error module.exports(rbreact/node_modules/fbjs/lib/nullthrows)
                */
            }

        }
        this.setCheckSpelling = () => {
            if (this.state.checkSpelling) {
                this.setState({ checkSpelling: false })
            } else {
                this.setState({ checkSpelling: true })
            }
            this.focus();
        }

        this.onDummyTextClick = (e) => {
            e.preventDefault(e);
            let editorState = EditorState.createWithContent(stateFromHTML(this.props.dummyValue));
            this.onChange(editorState);
        }

        this.setDomEditorRef = ref => {
            this.domEditor = ref
        };
        this.focus = () => {
            this.domEditor.focus();
            this.setState({
                isFocused: true
            })
        };
        this.handleBlur = () => {
            this.setState({
                isFocused: false
            })
        }
        this.showAIPopUp = () => {
            this.props.setShowAIPopup(!this.props.showAIPopup);
        }
        this.showPhrasePopUp = () => {
            this.props.setShowPhrasePopUp(!this.props.showPhrasePopUp);
        }
        this.btnSpActive = (v) => {
            this.setState({
                spActive: v
            })
        }
        this.btnRbaActive = (v) => {
            this.setState({
                rbaActive: v
            })
        }
        this.showSummaryToolTip = (v) => {
            this.setState({
                showSummaryToolTip: v
            })
            console.log(this.state);
        }
        
        this.getClassNames = () => {
            this.setState({
                cName: this.props.className
            })

        }
        this.showResumeBuilder = (v) => {
            this.setState({
                showResumeBuilder: v
            })
        }
        
    }
    componentDidMount(){
        this.setState({
            spActive: false,
            rbaActive: false,
            showSummaryToolTip: false
        });
    }
    componentWillReceiveProps(newProps) {
        /**
         * This will reset the state from the new prop if its value is not as same
         * as in the editor state. This will help the editor to switch between different
         * contents designated in the same DraftEditorComponent component.
         */
        if (newProps.value !== stateToHTML(this.state.editorState.getCurrentContent())) {
            if (newProps.value != '') {
                this.setState({
                    editorState: EditorState.createWithContent(stateFromHTML(newProps.value)),
                });
            } else {
                this.setState({
                    editorState: EditorState.createEmpty()
                });
            }
        }
    }

    render() {
        const {editorState} = this.state;
        // If the user changes block type before entering any text, we can
        // either style the placeholder or hide it. Let's just hide it now.
        let className = 'editor_wrap';
        var contentState = editorState.getCurrentContent();
        if (!contentState.hasText()) {
            if (contentState.getBlockMap().first().getType() !== 'unstyled') {
                className += ' RichEditor-hidePlaceholder';
            }
        }
        return <div className={this.props?.className + (this.state.isFocused ? " advanced-text-area focus" : " advanced-text-area")}>
            <div className="menubar">
                <div className="menubar-inner">
                    <button className="menubar__button bold" onClick={this.onBoldClick}>B</button>
                    <button className="menubar__button italic" onClick={this.onItalicsClick}><ItalicIcon /></button>
                    <button className="menubar__button underline" onClick={this.onUnderlineClick}>U</button>
                    <button className="menubar__button" onClick={this.onAddLinkClick}><LinkIcon /></button>
                    <button className="menubar__button abc" onClick={this.onStrikeClick}><del>S</del></button>
                    <button className="menubar__button bulletedNumList" onClick={this.onListingPointClick}><NumberListIcon /></button>
                    <button className="menubar__button bulletedList abc" onClick={this.onBulletPointClick}><BulletListIcon /></button>
                    {/* <button className="menubar__button abc" onClick={this.setCheckSpelling}><AbcIcon /></button> */}
                    <button className="menubar__button undoicon " onClick={this.onUndoClick}><UndoIcon /></button>
                    <button className="menubar__button redoicon" onClick={this.onRedoClick}><RedoIcon /></button>
                    {/* {this.props.dummyValue && <button  className="text-recommend" onClick={this.onDummyTextClick}>🤔Add Example Text</button>} */}
                </div>
                <div className="draft-controls">
                    <div className="ctrl-btns">
                    {(this.state.hidePhrasesButton && this.props.hasOwnProperty('phrasesButton') && this.props.phrasesButton)
                    ? <div className="phrases-wrap">
                        <button className={`phrases${(this.props.hasOwnProperty('colorType') && this.props.colorType) ? (' ' + this.props.colorType) : ''}${(this.state.spActive ? ' active' : '')}`} onClick={
                            () => {
                                this.btnSpActive(true);
                                this.btnRbaActive(false);
                                this.showPhrasePopUp();
                                if(this.props.showAIPopup) this.showAIPopUp();
                        }}><span><i className="plus-circle"><PlusCircleIcon /></i> Suggested Phrases</span></button>
                    </div> : ''}
                    {(this.props.hasOwnProperty('chatGptButton') && this.props.chatGptButton)
                    ? <div className="rb-ai-wrap">
                        <button className={`rb-ai${(this.props.hasOwnProperty('colorType') && this.props.colorType) ? (' ' + this.props.colorType) : ''}${(this.state.rbaActive ? ' active' : '')}`} onClick={
                            () => {
                                this.btnSpActive(false);
                                this.btnRbaActive(true);
                                this.showAIPopUp();
                                if(this.props.showPhrasePopUp) this.showPhrasePopUp();
                            }}><span><i className="icon-brain"></i> AI Writer </span></button>
                    </div> : ''}
                    {(this.props.hasOwnProperty('showRegenerateButton') && this.props.showRegenerateButton)
                    ? <div className="rb-ai-wrap">
                        <button className={`rb-ai${(this.props.hasOwnProperty('colorType') && this.props.colorType) ? (' ' + this.props.colorType) : ''}${(this.state.rbaActive ? ' active' : '')}`} onClick={
                            () => {
                                this.props.regenerateAction();
                            }}><span><i className="icon-brain"></i> Regenerate </span></button>
                    </div> : ''}
                    </div>
                    <div className="ctrl-icons">
                    {/* {
                        this.props.phrasesButton && window.innerWidth < 769 && 
                        <><div className="editor-info-wrap" onClick={() => {
                            this.showResumeBuilder(!this.state.showResumeBuilder);}}>
                            <i className={`editor-exp editor-info${this.state.showResumeBuilder ? ' icon-minus-icon' : ' icon-plus-icon'}`}></i>
                        </div></>
                    } */}
                    {
                        this.props.phrasesButton && 
                        <><div className="editor-info-wrap" onClick={(e) => {
                            if(!this.state.showSummaryToolTip){
                                this.showSummaryToolTip(true);
                            } else {
                                this.showSummaryToolTip(false);
                            }
                            
                        }}>
                            <i className="editor-info icon-info-circle"></i>
                        </div></>
                    }
                    {this.state.showSummaryToolTip && <SummaryToolTip showSummaryToolTip={this.state.showSummaryToolTip} setShowSummaryToolTip={(showSummaryToolTip) => { this.showSummaryToolTip(showSummaryToolTip) }} />}
                </div>
            </div>
            </div>
            <div className={className} onClick={this.focus}>
                <Editor
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    editorState={this.state.editorState}
                    onChange={this.onChange}
                    handleKeyCommand={this.handleKeyCommand}
                    ref={this.setDomEditorRef}
                    onBlur={() => {this.handleBlur(); this.props.onBlur ? this.props.onBlur() : ''}}
                    spellCheck={this.state.checkSpelling}
                    onFocus={this.props.onFocus}
                    //onBlur={this.props.onBlur}
                />
            </div>

        </div>
    }
}

export default DraftEditor;